export function applyTheme(city) {
  const root = document.documentElement;
  if (!city) {
    root.removeAttribute('style');
    return;
  }
  const c = city.colors;
  root.style.setProperty('--city-primary', c.primary);
  root.style.setProperty('--city-secondary', c.secondary);
  root.style.setProperty('--city-accent', c.accent);
  root.style.setProperty('--city-header-bg', c.headerBg);
  root.style.setProperty('--city-header-text', c.headerText);
  root.style.setProperty('--city-hero-bg', c.heroBg);
  root.style.setProperty('--city-hero-text', c.heroText);
  root.style.setProperty('--city-btn-primary', c.buttonPrimary);
  root.style.setProperty('--city-btn-primary-text', c.buttonPrimaryText);
  root.style.setProperty('--city-btn-secondary', c.buttonSecondary);
  root.style.setProperty('--city-card-accent', c.cardAccent);
  root.style.setProperty('--city-tag-bg', c.tagBg);
  root.style.setProperty('--city-tag-text', c.tagText);
  root.style.setProperty('--city-font', city.font || "'Lato', sans-serif");
}
